import { useEffect, useRef } from 'react';
import { useAudio, useAudioTime } from '../../../../../contexts';
export function useThumbMouseUp(setIsDragging) {
  var _useAudio = useAudio(),
      play = _useAudio.play,
      duration = _useAudio.duration;

  var _useAudioTime = useAudioTime(),
      currentTime = _useAudioTime.currentTime;

  var isEnded = useRef();
  isEnded.current = currentTime === duration; // We are using useRef to avoid the useEffect from updating.

  useEffect(function () {
    var handleMouseUp = function handleMouseUp() {
      setIsDragging(function (isDragging) {
        if (!isDragging) return isDragging; // no need to change the state.
        // Play audio on end of dragging. (We need to check the audio is not in the end to avoid jumping to the start).

        if (!isEnded.current) play();
        return false;
      });
    };

    document.addEventListener('mouseup', handleMouseUp);
    return function () {
      return document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [play, setIsDragging, isEnded]);
}